import React from 'react';
import { Table, Thead, Tbody, Row, HeadingCell, Cell } from './StyledTable';

export const Xv2pLimitTable = ({ limits }: { limits: any }) => {
  return (
    <Table>
      <Thead>
        <Row>
          <HeadingCell>Position</HeadingCell>
          <HeadingCell>Limit</HeadingCell>
          <HeadingCell>X</HeadingCell>
          <HeadingCell>Y</HeadingCell>
          <HeadingCell>Z</HeadingCell>
          <HeadingCell>Total exceedances across all axes</HeadingCell>
          <HeadingCell>Total samples with exceedance</HeadingCell>
        </Row>
      </Thead>
      <Tbody>
        {limits.map((limit, index) => (
          <Row>
            <Cell>{index === 0? 'Primary Limit' : 'Limit ' + (index + 1)}</Cell>
            <Cell>{limit.name}</Cell>
            <Cell>{limit.axis_exceedances.x}</Cell>
            <Cell>{limit.axis_exceedances.y}</Cell>
            <Cell>{limit.axis_exceedances.z}</Cell>
            <Cell>{limit.axis_exceedances.total_exceedances}</Cell>
            <Cell></Cell>
          </Row>
        ))}
      </Tbody>
    </Table>
  )
}